<!-- checkbox in table: https://xaksis.github.io/vue-good-table/guide/advanced/checkbox-table.html#configuration -->
<!-- input tag: https://github.com/matiastucci/vue-input-tag    /   https://tucci.me/vue-input-tag/-->

<template>
  <!-- modal information user -->
  <div
    class="modal fade"
    id="modal-select-apartment-send-notification"
    tabindex="-1"
    style="font: normal 14px FontAwesome; font-size: inherit"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="text-align:center">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 class="modal-title">{{ $t("component_address_book.title") }}</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <apartment-group-filter-component 
                  :btnDropDownTitle="btnDropDownTitle"
                  :isFilter="true"
                  :isHideNumberApartment="true"
                  :isHideManagementApartmentGroup="true"
                  @emitFilterApartmentInGroup="emitFilterApartmentInGroup"
                />
              </div>
            </div>
          </div>
          <!-- 
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-user"></i>
                </span>
                <input
                  v-on:keyup.enter="onSearchUser"
                  type="text"
                  class="form-control"
                  :placeholder="$t('user.code')"
                  v-model="search.code"
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <input
                v-on:keyup.enter="onSearchUser"
                type="text"
                class="form-control"
                :placeholder="$t('user.fullname')"
                v-model="search.full_name"
              />
            </div>
          </div>
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-mobile"></i>
                </span>
                <input
                  v-on:keyup.enter="onSearchUser"
                  type="text"
                  class="form-control"
                  :placeholder="$t('user.phone')"
                  v-model="search.phone"
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fa fa-envelope"></i>
                </span>
                <input
                  v-on:keyup.enter="onSearchUser"
                  type="text"
                  class="form-control"
                  :placeholder="$t('user.email')"
                  v-model="search.email"
                />
              </div>
            </div>
          </div>-->

          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <vue-good-table
                :columns="columns"
                :isLoading="isLoading"
                :rows="rows"
                :select-options="{ enabled: true }"
                :search-options="{
                  enabled: true,
                  placeholder: $t('component_address_book.search')
                }"
                @on-selected-rows-change="selectionChanged"
              >
                <template slot="loadingContent">
                  <div class="text-center text-danger my-2">
                    {{ $t("reportLiabilitiesReport.loading") }}
                  </div>
                </template>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'fullname'">
                    <span>{{
                      getFullName(props.row.first_name, props.row.last_name)
                    }}</span>
                  </span>
                  <span v-else-if="props.column.field == 'resident'">
                    <span>{{ props.row.resident.length }}</span>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>

          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-envelope-o">
                      <label>
                        <span style="margin-left:5px;display:inline-block;"
                          >{{ $t("component_address_book.to") }}:</span
                        >
                      </label>
                    </i>
                  </div>

                  <vue-input-tag
                    v-model="tagsApartmentCode"
                    validate="text"
                  ></vue-input-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-labeled pull-right"
            @click="doSelectEmail"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>

          <button
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.close") }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
  <!-- /.modal -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import constantsData from "@/lib/constantsData";
// import moment from "moment";

// import vue-good-table
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
// vue-input-tag
import InputTag from "vue-input-tag";
import ApartmentGroupFilterComponent from "../views/Apartment/ApartmentGroupFilterComponent.vue"
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import i18n from "../lang";

export default {
  name: "SelectUserModal",
  props: {
    userId: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    customerId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {
      tagsApartmentCode: [],
      apartmentCodeIds: [],
      apartmentDataList: [],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },

      columns: [
        {
          label: this.$t("customer.apartment_code"),
          field: "apartment_code"
        },
        {
          label: this.$t("apartment.numberResident"),
          field: "resident"
        }
      ],
      rows: [],
      isLoading: false,
      griduserDataList: [],
      callBackFrom: "",
      btnDropDownTitle: 'apartment.apartmentGroupFilterTitle',
      apartmentGroupIdFilter: []
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },

  methods: {
    ...mapActions([
      "GET_APARTMENT_LIST"
    ]),

    setCallBackFunction(from) {
      this.callBackFrom = from;
    },

    getFullName(firstname, lastname) {
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    selectionChanged(selectedRows) {
      // this.tagsApartmentCode = selectedRows.selectedRows.map(function(item) {
      //   this.apartmentCodeIds
      //   return apartmentCode: item.apartment_code, id: item.id ;
      // });
      this.apartmentCodeIds = [];
      this.tagsApartmentCode = [];
      this.apartmentDataList = [];
      selectedRows.selectedRows.forEach(item => {
        this.apartmentDataList.push({
          id: item.id,
          apartmentCode: item.apartment_code
        });
        this.apartmentCodeIds.push(item.id);
        this.tagsApartmentCode.push(item.apartment_code);
      });
    },
    doSelectEmail() {
      this.compareApartmentCode();
      // send data to method doSelectEmail
      let data = {
        callBackFrom: this.callBackFrom,
        tagsApartmentCode: this.tagsApartmentCode,
        apartmentCodeIds: this.apartmentCodeIds,
        apartmentDataList: this.apartmentDataList
      };
      this.$emit("doSelectEmail", data);
      // hide modal
      $("#modal-select-apartment-send-notification").modal("hide");
    },
    compareApartmentCode: function() {
      let apartmentCodeIds = [];
      this.rows.forEach(item => {
        if (this.tagsApartmentCode.includes(item.apartment_code)) {
          apartmentCodeIds.push(item.id);
        }
      });
      this.apartmentCodeIds = apartmentCodeIds;
    },
    emitFilterApartmentInGroup: function(data) {
      this.apartmentGroupIdFilter = data
      this.getApartmentList()
    },
    getApartmentList: function() {
      this.isLoading = true;
      let filter = {
        params: {
          asset: "asset",
          getApartmentHandedOverAndTenant: true,
          apartmentGroupIdFilter: this.apartmentGroupIdFilter
        }
      };
      this.GET_APARTMENT_LIST(filter)
        .then(
          function(res) {
            let data = res.data;
            this.rows = data;
            this.isLoading = false;
            return this.griduserDataList;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
  },
  mounted() {
    this.getApartmentList()
  },

  components: {
    "vue-good-table": VueGoodTable,
    "vue-input-tag": InputTag,
    ApartmentGroupFilterComponent,
    loading: Loading,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/SelectApartmentModal.vue